import React from 'react';
import { Link } from 'react-router-dom';
import { matchRoutes } from 'react-router-config';
import { BreadcrumbExt as LegaoBreadcrumb } from "@jdcfe/legao";
import routes from 'routes';

const Breadcrumb = ({ path: currentPath }) => {
  let matchedRoutes = matchRoutes(routes, currentPath);
  matchedRoutes = matchedRoutes.filter(matchRoute => matchRoute.route.breadcrumbName);

  // console.log('matchedRoutes: ', matchedRoutes, routes, currentPath);

  return (
    <LegaoBreadcrumb>
      {
        matchedRoutes.map((matchRoute) => {
          const { path, breadcrumbName } = matchRoute.route;

          const isActive = path === currentPath;

          const itemNode = isActive 
            ? <span key={path}>{breadcrumbName}</span>
            : <Link key={path} to={path}>{breadcrumbName}</Link>;

          return <LegaoBreadcrumb.Item key={path}>{itemNode}</LegaoBreadcrumb.Item>;
        })
      }
    </LegaoBreadcrumb>
  );
};

export default Breadcrumb;